// Assigns location to ticket, including car and parking spot details.
import React from 'react';
import styles from '../css/ticketEntry.module.css';
import { useNavigate } from 'react-router-dom';
import { FaParking, FaCarSide } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import { serverURL } from '../helpers/dataServerURL';
import { showSectionsAndSpaces } from '../helpers/databaseAPI';

export default function AssignLocation({
  section,
  setSectionCaption,
  setLaneMin,
  setLaneMax,
  lane,
  setLane,
  spot,
  setSpot,
  sectionRef,
  laneRef,
  spotRef,
  isOpen,
  setIsOpen,
}) {
  const navigate = useNavigate();
  const [sectionsArray, setSectionArray] = useState([]);

  useEffect(() => {
    const plotSections = async () => {
      setSectionArray(await showSectionsAndSpaces(loginURL));
      // sectionsArrayRef.current = sectionsArray;
    };
    plotSections();
  }, []);

  const loginURL = serverURL.server.url;

  const btnsNames = sectionsArray.map((section) => (
    <button
      className={styles.sectionButton}
      onClick={(e) => {
        setIsOpen(true);
        navigate('/ticketEntry', {
          state: {
            selectedSection: section.SectionCaption,
            // I can also use e.textContent
          },
        });
        // I used e.currentTarget.textContent because e.textContent is not a valid DOM property
        // console.log(section.SectionCaption, e.currentTarget.textContent, 'button caption');
      }}
    >
      <div className={styles.sectionsBtnContainer} key={section.id}>
        <div style={{ display: 'flex', gap: '5px' }}>
          <FaParking />
          <span>{section.SectionCaption}</span>
        </div>

        <div style={{ display: 'flex', gap: '5px' }}>
          <FaCarSide />
          <span style={{ color: 'white' }}>
            {section.LaneNumMin}-{section.LaneNumMax}
          </span>
        </div>
      </div>
    </button>
  ));

  return (
    <div className={styles.groupsContainer2}>
      {btnsNames.length > 0 && btnsNames}
      <input
        ref={sectionRef}
        type="text"
        value={section || ''}
        className={styles.miscInput}
        placeholder="Section"
        id="section"
        readOnly
        required
      />
      <input
        ref={laneRef}
        type="text"
        value={lane || ''}
        className={styles.miscInput}
        placeholder="Lane"
        id="lane"
        readOnly
        required
      />
      <input
        ref={spotRef}
        type="text"
        value={spot || ''}
        className={styles.miscInput}
        placeholder="Spot"
        id="spot"
        required
        readOnly
      />
    </div>
  );
}
